<template>
    <el-form-item :class="['custom-form-item', {'flex-start': start}]" :style="{marginBottom: bottom}" :prop="prop" :rules="rules" >
        <span v-if="label" class="from-left-lable x-left-option-text" :class="{'weight-title': bold}" :style="{width: labelWidth}">
            <span class="box x-flex-align">
                <i v-if="required" class="x-required-stars">*</i>
                <span :class="[{'x-grey-text': !bold}, {'x-option': optionText}]">{{label}}</span>
            </span>
        </span>
        <span v-if="label" :class="['x-grey-text', {'hidden': bold}]">：</span>
        <span :class="['x-flex-align x-flex-one', {'x-overflow-hidden': overflow}, {'x-flex-justify': center}]">
            <slot></slot>
            <span v-if="symbol" class="x-grey-text form-item-symbol">{{symbol}}</span>
        </span>
        <span slot="error" class="x-form-item-error" :style="{left: labelWidth == 'auto' ? '60px' : labelWidth, paddingLeft: label ? '14px' : '0px'}"  slot-scope="scope">{{scope.error}}</span>
    </el-form-item>
</template>

<script>
export default {
  name: 'MyFormItem',
  props: {
    prop: { // 验证的字段名
      type: String,
      default: ''
    },
    label: { // label文字
      type: String,
      default: ''
    },
    labelWidth: { // label宽度
      type: String,
      default: '115px'
    },
    optionText: { // label文字对齐(仅支持四个字)
      type: Boolean,
      default: true
    },
    required: { // 必填
      type: Boolean,
      default: false
    },
    bold: { // label加粗(仅用于体检记录)
      type: Boolean,
      default: false
    },
    bottom: { // margin-bottom
      type: String,
      default: '28px'
    },
    overflow: { // 超出隐藏
      type: Boolean,
      default: false
    },
    center: { // 水平居中
      type: Boolean,
      default: false
    },
    symbol: { // 单位(位于输入框之后)
      type: String,
      default: ''
    },
    start: { // 垂直居中方式(默认居中)
      type: Boolean,
      default: false
    },
    rules: {
      type: [Object, Array],
    }
  }
};
</script>

<style lang="scss" scoped>

.custom-form-item {
    box-sizing: border-box;
    width: 100%;

    // 左边文字
    .from-left-lable {
        height: 30px;
        line-height: 30px;

        .box {
            position: relative;
        }
    }

    // 冒号
    .x-grey-text {
        height: 30px;
        line-height: 30px;
        // line-height: 14px;
    }
    
    // 加粗标题
    .weight-title {
        margin-right: 14px;
        color: #1D2944;
        font-weight: 600;
        line-height: 14px;
    }

    // 隐藏冒号
    .hidden {
        display: none;
    }
    
    // 单位
    .form-item-symbol {
        margin-left: 5px;
        white-space: nowrap;
    }
}
</style>

<style lang="scss">

.custom-form-item {
    
    .el-form-item__content {
        display: flex;
        align-items: center;
        padding: 0;

        // 错误信息
        .x-form-item-error {
            position: absolute;
            top: 100%;
            padding-top: 4px;
            color: #F56C6C;
            font-size: 12px;
            line-height: 12px;
            white-space: nowrap;
        }
    }    
}

.custom-form-item.flex-start {
    .el-form-item__content {
        align-items: flex-start;
    }
}
</style>



